<template>
  <chart-stats-table :songs="songs"/>
</template>

<script>
import ChartStatsTable from './ChartStatsTable.vue'

export default {
  components: { ChartStatsTable },
  props: {
    songs: { type: Array, default: () => [] },
  },
}
</script>
